export default __webpack_public_path__ + "static/Phuong_Lai-67024b9ea0d01da948e3262b232f3000.png";